<template>
  <section>
    <form
      ref="formRef"
      method="post"
      :action="`/my/orders/${purchaseId}/items/${itemId}/resend`"
      enctype="multipart/form-data"
      novalidate
      @submit.prevent="handleSubmit"
    >
      <csrf-input />
      <div class="order-details">
        {{ toEmail }}<br />
        Not Redeemed
        <div>
          <button
            type="button"
            class="btn -anchor-link -order-action"
            @click.prevent="openConfirmModal"
          >
            {{ submitted ? 'Sending...' : 'Resend' }}
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CsrfInput from '@/components/forms/csrf-input.vue'
import { mapState, mapActions } from 'pinia'
import { useModalsStore } from '@/stores/modals'

export default defineComponent({
  name: 'ResendGiftMessage',
  components: { CsrfInput },
  props: {
    purchaseId: {
      type: String,
      required: true,
    },
    itemId: {
      type: String,
      required: true,
    },
    toEmail: {
      type: String,
      required: true,
    },
  },

  //  state
  data() {
    return {
      submitted: false,
    }
  },

  computed: {
    ...mapState(useModalsStore, ['simpleModal']),

    modalSubheading() {
      return (
        'Resend email notification to <strong>' +
        this.toEmail +
        '</strong>. If this email address is incorrect or you want to change to a different recipient, please <a href="/page/contact-us">contact support</a>.'
      )
    },

    modalId() {
      return `resend-item-${this.itemId}-modal`
    },
  },

  watch: {
    'simpleModal.action'(newAction: string, prevAction: string) {
      if (
        this.simpleModal.id === this.modalId &&
        newAction !== prevAction &&
        newAction === 'confirm' &&
        !this.submitted
      ) {
        this.handleSubmit()
      }
    },
  },

  // instance methods
  methods: {
    ...mapActions(useModalsStore, ['openSimpleModal']),

    async handleSubmit() {
      if (this.submitted) {
        return
      }

      this.submitted = true

      // traditional form submit
      if (this.$refs.formRef instanceof HTMLFormElement) {
        // wait until next tick to make sure v-model update
        await this.$nextTick()
        this.$refs.formRef.submit()
      }
    },

    openConfirmModal() {
      if (this.submitted) {
        return
      }

      this.openSimpleModal({
        type: 'CONFIRM',
        id: this.modalId,
        props: {
          heading: 'Need to Resend?',
          subheading: this.modalSubheading,
          buttonText: 'Resend',
          cancelText: 'Cancel',
        },
      })
    },
  },
})
</script>
